<div class="container">
    <div fxLayout="row" fxLayout.xs="column">
        <!-- <div fxFlex="5" style="margin: 5px;">
            <img src="https://via.placeholder.com/300/09f/fff.png" style="width: 100%;height: 50px;"/>
        </div> -->
        <div fxFlex="50" style="padding-left: 10px;" class="aligncss">
            <h2><b>{{name}}</b></h2>
            <p><b>{{Address}}</b></p>
        </div>
        <div fxFlex="50" *ngIf="data.enableVoiceReaderInDetailPage==1">
            <calsoft-speechtext [speechArray]="speechArray"></calsoft-speechtext>
        </div>
    </div>

    <div *ngIf="imageList.length == '1'">
        <div fxLayout="row" fxLayout.xs="column" *ngFor="let image of imageList; let i=index">
            <div fxFlex="100" style="padding: 10px;" fxFlex.xs="100">
                <div *ngIf="image=='sassa'">
                    <img [alt]="name" class="imgH" src="src/assets/images/products/noImage/no-image.png">
                </div>

                <div *ngIf="image!='sassa'">
                    <div
                        *ngIf="!image.includes('medicineimages')&&!image.includes('http')&&!image.includes('commonimages')">
                        <img [src]="bigImage+image | safe: 'resourceUrl'"
                            onerror="this.src='assets/images/products/noImage/no-image.png';" class="primarycss1" />
                    </div>

                    <div *ngIf="image.includes('http')">
                        <img [src]="image | safe: 'resourceUrl'"
                            onerror="this.src='assets/images/products/noImage/no-image.png';" class="primarycss1" />
                    </div>

                    <div *ngIf="image.includes('medicineimages')">
                        <img [src]="commonImageApi+image| safe: 'resourceUrl'"
                            onerror="this.src='assets/images/products/noImage/no-image.png';" class="primarycss1" />
                    </div>

                    <div *ngIf="image.includes('commonimages')">
                        <img [src]="serverPath7+image| safe: 'resourceUrl'"
                            onerror="this.src='assets/images/products/noImage/no-image.png';" class="primarycss1" />
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div *ngIf="imageList.length == 2">
        <div fxLayout="row" fxLayout.xs="column" *ngIf="isImageValid()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="bigImage+imageList[0]" style="height: 100%;" class="primarycss" />
            </div>
            <div fxFlex="50">
                <div class="secondaryimage">
                    <div style="margin: 10px;">
                        <img [src]="bigImage+imageList[1]" style="width: 100%;height: 100%;" class="primary_css" />
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="idHttp()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="imageList[0]" style="height: 100%;" class="primarycss" />
            </div>
            <div fxFlex="50">
                <div class="secondaryimage">
                    <div style="margin: 10px;">
                        <img [src]="imageList[1]" style="width: 100%;height: 100%;" class="primary_css" />
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="medicineImg()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="commonImageApi+imageList[0]" style="height: 100%;" class="primarycss" />
            </div>
            <div fxFlex="50">
                <div class="secondaryimage">
                    <div style="margin: 10px;">
                        <img [src]="commonImageApi+imageList[1]" style="width: 100%;height: 100%;"
                            class="primary_css" />
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="containsCommonImages()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="serverPath7+imageList[0]" style="height: 100%;" class="primarycss" />
            </div>
            <div fxFlex="50">
                <div class="secondaryimage">
                    <div style="margin: 10px;">
                        <img [src]="serverPath7+imageList[1]" style="width: 100%;height: 100%;" class="primary_css" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="imageList.length == 3">
        <div fxLayout="row" fxLayout.xs="column" *ngIf="isImageValid()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="bigImage+imageList[0]" style="width: 100%;height: 100%;" />
            </div>
            <div fxFlex="50" fxLayout="column">
                <div class="secondaryimage">
                    <div style="margin: 10px;">
                        <img [src]="bigImage+imageList[1]"
                            style="width: 100%;height: 100%;border-top-right-radius: 20px;" />
                    </div>
                    <div style="margin: 10px;">
                        <img [src]="bigImage+imageList[2]"
                            style="width: 100%;height: 100%;border-bottom-right-radius: 20px;" />
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="idHttp()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="imageList[0]" style="width: 100%;height: 100%;" />
            </div>
            <div fxFlex="50" fxLayout="column">
                <div class="secondaryimage">
                    <div style="margin: 10px;">
                        <img [src]="imageList[1]" style="width: 100%;height: 100%;border-top-right-radius: 20px;" />
                    </div>
                    <div style="margin: 10px;">
                        <img [src]="imageList[2]" style="width: 100%;height: 100%;border-bottom-right-radius: 20px;" />
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="medicineImg()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="commonImageApi+imageList[0]" style="height: 100%;" class="primarycss" />
            </div>
            <div fxFlex="50" fxLayout="column">
                <div class="secondaryimage">
                    <div style="margin: 10px;">
                        <img [src]="commonImageApi+imageList[1]"
                            style="width: 100%;height: 100%;border-top-right-radius: 20px;" />
                    </div>
                    <div style="margin: 10px;">
                        <img [src]="commonImageApi+imageList[2]"
                            style="width: 100%;height: 100%;border-bottom-right-radius: 20px;" />
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="containsCommonImages()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="serverPath7+imageList[0]" style="height: 100%;" class="primarycss" />
            </div>
            <div fxFlex="50" fxLayout="column">
                <div class="secondaryimage">
                    <div style="margin: 10px;">
                        <img [src]="serverPath7+imageList[0]"
                            style="width: 100%;height: 100%;border-top-right-radius: 20px;" />
                    </div>
                    <div style="margin: 10px;">
                        <img [src]="serverPath7+imageList[0]"
                            style="width: 100%;height: 100%;border-bottom-right-radius: 20px;" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="imageList.length == 4">

        <div fxLayout="row" fxLayout.xs="column" *ngIf="isImageValid()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="bigImage+imageList[0]" style="height: 100%;" class="primarycss" />
            </div>
            <div fxFlex="50">
                <div class="secondaryimage">
                    <div fxLayout="row">
                        <div fxFlex="100" style="margin: 10px;">
                            <img [src]="bigImage+imageList[1]" style="width: 100%;" />
                        </div>
                    </div>
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="bigImage+imageList[2]" style="width: 100%;border-top-right-radius: 20px;" />
                        </div>
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="bigImage+imageList[3]" style="width: 100%;border-bottom-right-radius: 20px;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="idHttp()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="imageList[0]" style="height: 100%;" class="primarycss" />
            </div>
            <div fxFlex="50">
                <div class="secondaryimage">
                    <div fxLayout="row">
                        <div fxFlex="100" style="margin: 10px;">
                            <img [src]="imageList[1]" style="width: 100%;border-top-right-radius: 20px;" />
                        </div>
                    </div>
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="imageList[2]" style="width: 100%;" />
                        </div>
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="imageList[3]" style="width: 100%;border-bottom-right-radius: 20px;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="medicineImg()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="commonImageApi+imageList[0]" style="height: 100%;" class="primarycss" />
            </div>
            <div fxFlex="50">
                <div class="secondaryimage">
                    <div fxLayout="row">
                        <div fxFlex="100" style="margin: 10px;">
                            <img [src]="commonImageApi+imageList[1]"
                                style="width: 100%;border-top-right-radius: 20px;" />
                        </div>
                    </div>
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="commonImageApi+imageList[2]" style="width: 100%;" />
                        </div>
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="commonImageApi+imageList[3]"
                                style="width: 100%;border-bottom-right-radius: 20px;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="containsCommonImages()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="serverPath7+imageList[0]" style="height: 100%;" class="primarycss" />
            </div>
            <div fxFlex="50">
                <div class="secondaryimage">
                    <div fxLayout="row">
                        <div fxFlex="100" style="margin: 10px;">
                            <img [src]="serverPath7+imageList[1]" style="width: 100%;border-top-right-radius: 20px;" />
                        </div>
                    </div>
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="serverPath7+imageList[2]" style="width: 100%;" />
                        </div>
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="serverPath7+imageList[3]"
                                style="width: 100%;border-bottom-right-radius: 20px;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


    <div *ngIf="imageList.length == 5">

        <div fxLayout="row" fxLayout.xs="column" *ngIf="isImageValid()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="bigImage+imageList[0]" class="primarycss" />
            </div>
            <div fxFlex="50" class="secondary-image">
                <div fxLayout="row">
                    <div fxFlex="50" style="margin: 10px;">
                        <img [src]="bigImage+imageList[1]" style="width: 100%;height: 100%;" />
                    </div>
                    <div fxFlex="50" style="margin: 10px;">
                        <img [src]="bigImage+imageList[2]"
                            style="width: 100%;border-top-right-radius: 20px;height: 100%;" />
                    </div>
                </div>
                <div fxLayout="row">
                    <div fxFlex="50" style="margin: 10px;">
                        <div fxLayout="row">
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="bigImage+imageList[3]" style="width: 100%;height: 100%;" />
                            </div>
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="bigImage+imageList[4]"
                                    style="width: 100%;border-bottom-right-radius: 20px;height: 100%;" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="idHttp()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="imageList[0]" class="primarycss" />
            </div>
            <div fxFlex="50" class="secondary-image">
                <div fxLayout="row">
                    <div fxFlex="50" style="margin: 10px;">
                        <img [src]="imageList[1]" style="width: 100%;height: 100%" />
                    </div>
                    <div fxFlex="50" style="margin: 10px;">
                        <img [src]="imageList[2]" style="width: 100%;border-top-right-radius: 20px;height: 100%" />
                    </div>
                </div>
                <div fxLayout="row">
                    <div fxFlex="50" style="margin: 10px;">
                        <div fxLayout="row">
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="imageList[3]" style="width: 100%;height: 100%" />
                            </div>
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="imageList[4]"
                                    style="width: 100%;border-bottom-right-radius: 20px;height: 100%" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" *ngIf="medicineImg()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="commonImageApi+imageList[0]" class="primarycss" />
            </div>
            <div fxFlex="50" class="secondary-image">
                <div fxLayout="row">
                    <div fxFlex="50" style="margin: 10px;">
                        <img [src]="commonImageApi+imageList[1]" style="width: 100%;height: 100%" />
                    </div>
                    <div fxFlex="50" style="margin: 10px;">
                        <img [src]="commonImageApi+imageList[2]"
                            style="width: 100%;border-top-right-radius: 20px;height: 100%" />
                    </div>
                </div>
                <div fxLayout="row">
                    <div fxFlex="50" style="margin: 10px;">
                        <div fxLayout="row">
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="commonImageApi+imageList[3]" style="width: 100%;height: 100%" />
                            </div>
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="commonImageApi+imageList[4]"
                                    style="width: 100%;border-bottom-right-radius: 20px;height: 100%" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div fxLayout="row" fxLayout.xs="column" *ngIf="containsCommonImages()">
            <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                <img [src]="serverPath7+imageList[0]" class="primarycss" />
            </div>
            <div fxFlex="50" class="secondary-image">
                <div fxLayout="row">
                    <div fxFlex="50" style="margin: 10px;">
                        <img [src]="serverPath7+imageList[1]" style="width: 100%;height: 100%" />
                    </div>
                    <div fxFlex="50" style="margin: 10px;">
                        <img [src]="serverPath7+imageList[2]"
                            style="width: 100%;border-top-right-radius: 20px;height: 100%" />
                    </div>
                </div>
                <div fxLayout="row">
                    <div fxFlex="50" style="margin: 10px;">
                        <img [src]="serverPath7+imageList[3]" style="width: 100%;height: 100%" />
                    </div>
                    <div fxFlex="50" style="margin: 10px;">
                        <img [src]="serverPath7+imageList[4]"
                            style="width: 100%;border-bottom-right-radius: 20px;height: 100%" />
                    </div>
                </div>

            </div>
        </div>

    </div>

    <div fxLayout="row">
        <div fxFlex="70" fxFlex.xs="100">
            <p class="detailcss" [innerHTML]="description"></p>
        </div>
        <div fxFlex="30" class="secondary-image">

            <div class="cs-booking-form-belowSlider">
                <div fxLayoutAlign="start center" class="booking">
                    <div class="search_in" >
                        <b>{{name}}</b>
                    </div>
                </div>

                <div fxLayoutAlign="start center" class="booking">
                    <div class="iconContainer">
                        <div class="item">
                            <mat-icon>hotel</mat-icon>
                            <span>Overnight Stay</span>
                        </div>
                    
                        <div class="item">
                            <mat-slide-toggle [(ngModel)]="isFormFieldDisabled"></mat-slide-toggle>
                        </div>
                    
                        <div class="item">
                            <mat-icon>wb_sunny</mat-icon>
                            <span>Day Rooms</span>
                        </div>
                    </div>
                    
                </div>

                <div fxLayoutAlign="start center">
                    <mat-form-field appearance="outline" fxFlex="100" style="font-size: 16px;">
                        <mat-label>{{formattedDate}}
                        </mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                          <input matStartDate [(ngModel)]="startDate">
                          <input matEndDate [(ngModel)]="endDate">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field>
                </div>

                <div *ngIf="isFormFieldDisabled==false" fxLayoutAlign="start center">
                    <mat-form-field appearance="outline" fxFlex="100" [disabled]="isFormFieldDisabled" style="font-size: 16px;">
                        <mat-label>{{formattedTomorrowDate}}
                        </mat-label>
                        <mat-date-range-input  [rangePicker]="picker">
                          <input matStartDate [(ngModel)]="startDatenew">
                          <input matEndDate [(ngModel)]="endDatenew">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field>
                </div>

                <div>
                    <mat-accordion>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header (click)="togglePanel()">
                                <mat-panel-description>
                                    <div fxLayout="row" fxFlex="100">

                                        <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Rooms</mat-label>
                                            <input [(ngModel)]="guestCount" matInput style="font-size: 16px;">
                                            <mat-icon matSuffix>person
                                            </mat-icon>
                                        </mat-form-field>
                                    </div>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                
                            <div *ngIf="panelOpen" clickOutside (clickOutside)="closePanel()">
                                <div fxLayout="column" fxLayoutGap="10px">
                                    <div *ngFor="let room of bookingInfo; let i = index">
                                        <input type="text" [(ngModel)]="room.info" placeholder="Room {{i + 1}} - {{room.adults}} Adult" readonly style="border: none;">
                                        <div fxLayout="row" fxLayoutAlign="start center" style="background-color: #F6F5F5;padding: 10px;">
                                            <div fxFlex="50">
                                                <span class="label" style="color: gray;">Adult</span>
                                                <button mat-icon-button (click)="decrementAdult(room)">
                                                    <mat-icon>remove</mat-icon>
                                                </button>
                                                <input type="number" [(ngModel)]="room.adults" style="width: 20%;border: none;text-align: end;" readonly>
                                                <button mat-icon-button (click)="incrementAdult(room)">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </div>
                                            <div fxFlex="50">
                                                <span class="label" style="color: gray;">Children</span>
                                                <button mat-icon-button (click)="decrementChildren(room)">
                                                    <mat-icon>remove</mat-icon>
                                                </button>
                                                <input type="number" [(ngModel)]="room.children" style="width: 20%;border: none;text-align: end" readonly>
                                                <button mat-icon-button (click)="incrementChildren(room)">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <a mat-button (click)="addRoom()" class="morebtn">ADD MORE ROOMS</a> -->
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>

                <div>
                    <!-- <button fxFlex="100" class="primary" style="color: white;" mat-button>Book Now
                    </button> -->

                    <div fxLayout="row" style="padding-top: 10px;" fxFlex="100">
                        <div fxFlex="100" *ngIf="product.type!='Subscription'">   
                            <div *ngIf="isInStock==1">
                                <calsoft-controls [data]="data"
                                    *ngIf="(qty>0 && isInStock==1)||(manageStock==0); else elseBlock" fxHide.xs
                                    fxShow.lt-lg [productCustomOption]="productCustomOption" [coversionTrackingIdGa]="coversionTrackingIdGa"
                                    [productOption]="salesFlatQuoteItemOption" [product]="configProductSelected"
                                    [configproduct]="product" [type]="'navigationButton'" [buttonArray]="buttonArray"
                                    [configproduct]="product">
                                </calsoft-controls>
                            </div>

                        </div>

                    </div>
                </div>
                

            </div>

        </div>
    </div>

    <div fxHide.lt-md>
        <div fxLayout="row" style="margin-top: 20px;">
            <div fxFlex="70">
                <div fxFlex>
                    <div class="iconcss">
                        <img src="assets/logo/Restaurant.png"
                            class="iconimg" />
                        <p>Restaurant</p>
                    </div>
                </div>
                <div fxFlex>
                    <div class="iconcss">
                        <img src="assets/logo/Fitness.png"
                            class="iconimg" />
                        <p>Fitness Center</p>
                    </div>
                </div>

                <div fxFlex>
                    <div class="iconcss">
                        <img src="assets/logo/Transportation.png"
                            class="iconimg" />
                        <p>Transportation</p>
                    </div>
                </div>

                <div fxFlex>
                    <div class="iconcss">
                        <img src="assets/logo/Swimming.png"
                            class="iconimg" />
                        <p>Swimming Pool</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- mobile view -->

    <div fxHide fxShow.lt-md>

        <div fxLayout="row" style="margin-top: 20px;">
            <div fxFlex="50" style="border: 1px solid lightgray;padding: 15px;">
                <div class="iconcss1">
                    <img src="assets/logo/Restaurant.png"
                        class="iconimg" />
                    <p>Restaurant</p>
                </div>
            </div>
            <div fxFlex="50" style="border: 1px solid lightgray;padding: 15px;">
                <div class="iconcss1">
                    <img src="assets/logo/Fitness.png"
                        class="iconimg" />
                    <p>Fitness Center</p>
                </div>
            </div>
        </div>
        <div fxLayout="row">
            <div fxFlex="50" style="border: 1px solid lightgray;padding: 15px;">
                <div class="iconcss1">
                    <img src="assets/logo/Transportation.png"
                        class="iconimg" />
                    <p>Transportation</p>
                </div>
            </div>
            <div fxFlex="50" style="border: 1px solid lightgray;padding: 15px;">
                <div class="iconcss1">
                    <img src="assets/logo/Swimming.png" class="iconimg" />
                    <p>Swimming Pool</p>
                </div>
            </div>
        </div>
    </div>



</div>

<div [class.container]="data.layoutDisplayTypeInDetailpage != '1'" *ngIf="init">
    <calsoft-layout [value]="3" [homePageData]="homePageBuilder" [type]="2"></calsoft-layout>
</div>

<ng-template #elseBlock>

    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="2px">
        <div fxLayout="row">
            <h2>Not Available</h2>
        </div>
        <!-- <div fxLayout="row" class="padding-3" fxFlex>
            <span>This item is currently out of stock</span>

        </div> -->
        <div fxLayout="row" fxFlex>

            <button mat-raised-button (click)="initOutStockFunction()" color="warn"
                class="btn btn-small btn-info padding-10" type="button" data-bind="click: ok">
                Notify Me
            </button>

        </div>

    </div>

</ng-template>